import {
  Box,
  Typography,
  TextField,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Divider,
  Tabs,
  Tab,
  ThemeProvider,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  ListItemIcon,
} from '@mui/material';
import {
  Search as SearchIcon,
  Folder as FolderIcon,
  ArrowBackIos as ArrowBackIosIcon,
  Add as AddIcon,
  FolderOpen as FolderOpenIcon,
} from '@mui/icons-material';
import { useState } from 'react';
import { theme } from '../../style/theme';
import NewComponent from './NewComponent';
// import ParentComponent from './ParentComponent';

const NewFileTab = () => {
  const [selectedTab, setSelectedTab] = useState('New');
  const [tab, setTab] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');

  const projects = [
    { name: 'Project 21', date: '2025-01-15' },
    { name: 'Project EON', date: '2025-01-15' },
    { name: 'Project HTL', date: '2025-02-23' },
    { name: 'Project 09', date: '2025-01-15' },
  ];

  const handleSidebarClick = (tab) => {
    setSelectedTab(tab);
  };

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const filteredProjects = projects.filter((project) =>
    project.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const renderContent = () => {
    switch (selectedTab) {
      case 'New':
        return <NewComponent />;
      default:
        return <NewComponent />;
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ display: 'flex', overflowY: 'scroll' }}>
        {/* navigation bar */}
        {/* <ParentComponent /> */}

        {/* Sidebar */}
        <Box
          sx={{
            width: '15rem',
            bgcolor: '#ffffff',
            py: '1.5rem',
            borderRight: '1px solid #e0e0e0',
          }}
        >
          {/* Back Button */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              margin: '1.2rem',
              cursor: 'pointer',
              mt: '4rem',
            }}
          >
            <IconButton onClick={() => window.history.back()}>
              <ArrowBackIosIcon sx={{ color: 'secondary.main' }} />
            </IconButton>
          </Box>

          {/* First List: New & Open */}
          <List>
            {['New', 'Open'].map((item, index) => (
              <ListItem
                key={index}
                button
                sx={{
                  bgcolor:
                    selectedTab === item ? 'secondary.default' : 'transparent',
                  '&:hover': { bgcolor: '#f0f0f0' },
                  marginBottom: '0.5rem',
                  borderRadius: '0.2rem',
                  borderRight:
                    selectedTab === item ? '4px solid #0033A0' : 'none',
                }}
                onClick={() => handleSidebarClick(item)}
              >
                <ListItemIcon>
                  {item === 'New' && (
                    <AddIcon sx={{ color: 'secondary.main' }} />
                  )}
                  {item === 'Open' && (
                    <FolderOpenIcon sx={{ color: 'secondary.main' }} />
                  )}
                </ListItemIcon>
                <ListItemText primary={item} />
              </ListItem>
            ))}
          </List>

          {/* Divider */}
          <Divider sx={{ m: 2 }} />

          {/* Heading for Second List */}
          <Typography
            variant="body2"
            sx={{
              textAlign: 'center',
              fontSize: '0.75rem',
              color: 'text.secondary',
              mb: 1,
            }}
          >
            Get Add-ins
          </Typography>

          {/* Second List: Save & Save As (Centered) */}
          <List sx={{ textAlign: 'center' }}>
            {['Save', 'Save As'].map((item, index) => (
              <ListItem
                key={index}
                button
                sx={{
                  bgcolor:
                    selectedTab === item ? 'secondary.default' : 'transparent',
                  '&:hover': { bgcolor: '#f0f0f0' },
                  marginBottom: '0.5rem',
                  borderRadius: '0.2rem',
                  borderRight:
                    selectedTab === item ? '4px solid #0033A0' : 'none',
                  justifyContent: 'center', // Center text and icon
                  alignItems:'center',
                  paddingLeft:'3.5rem',
                }}
                onClick={() => handleSidebarClick(item)}
              >
                
                <ListItemText primary={item} />
              </ListItem>
            ))}
          </List>
        </Box>

        {/* Main Content */}
        <Box sx={{ flexGrow: 1, backgroundColor: 'background.main', padding: '2rem' }}>
          {renderContent()}

          {/* Divider */}
          <Divider />
          <Box
            sx={{ display: 'flex', flexDirection: 'column', margin: '4rem' }}
          >
            {/* Search Bar with Filter */}
            <TextField
              placeholder="Search"
              value={searchTerm}
              onChange={handleSearchChange}
              InputProps={{
                endAdornment: (
                  <IconButton>
                    <SearchIcon />
                  </IconButton>
                ),
              }}
              fullWidth
              sx={{
                marginBottom: '1.5rem',
                borderRadius: '0.9375rem',
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: 'rgba(0, 0, 0, 0.5)',
                  },
                },
                width: '60%',
                fontSize: '0.938rem',
                backgroundColor:'background.default',
                '& .MuiInputBase-input': {
                  padding: '1rem',
                  fontSize: '0.938rem',
                },
                '&.Mui-focused': { boxShadow: '0 0 3px rgba(11, 12, 12, 0.5)' },
              }}
            />

            {/* Tabs */}
            <Tabs
              value={tab}
              onChange={handleTabChange}
              sx={{ marginBottom: '1.5rem' }}
            >
              <Tab label="Recent" />
              <Tab label="Pinned" />
            </Tabs>

            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ color: 'text.secondary' }}>
                      Project Name
                    </TableCell>
                    <TableCell
                      sx={{ color: 'text.secondary', textAlign: 'right' }}
                    >
                      Date Modified
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredProjects.map((project, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '1rem',
                          }}
                        >
                          <FolderIcon sx={{ color: 'secondary.main' }} />
                          <Typography>{project.name}</Typography>
                        </Box>
                      </TableCell>
                      <TableCell sx={{ textAlign: 'right' }}>
                        <Typography variant="body2" color="textSecondary">
                          {project.date}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default NewFileTab;
